module.exports = __webpack_public_path__ + "static/media/view teachers evaluation.35d2f1e3.svg";